import * as actionsMap from './actions';

export const notifyActionOpenNotification = (push, { games, lang, syncClose, dispatch }) => {
    const { action, actionId } = push.data;

    if (!action) {
        return null;
    }

    // assume each push notification can have only one action
    const [actionType, actionInfo] = Object.entries(action)[0] || [];
    const actionHandler = actionsMap[actionType];

    if (!actionType || !actionInfo || !actionHandler) {
        return null;
    }

    return actionHandler({ actionId, actionInfo, push }, { games, lang, syncClose, dispatch });
};
